var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.isUpdateDynamicCronjob,
        width: "650px",
        "before-close": _vm.handleClose,
        top: "10vh",
        close: _vm.handleClose,
        "custom-class": "modern-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isUpdateDynamicCronjob = $event
        },
        open: _vm.handleOpen,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "dialog-footer-themed" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        plain: "",
                        size: "medium",
                        icon: "el-icon-circle-close",
                      },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("\n        Đóng\n      ")]
                  ),
                  !_vm.showDetail
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "medium",
                            icon: "el-icon-circle-check",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.handleUpload },
                        },
                        [_vm._v("\n        Lưu lại\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "dialog-header-themed" }, [
        _c("div", { staticClass: "themed-icon" }, [
          _c("i", {
            class: _vm.showDetail ? "el-icon-monitor" : "el-icon-edit",
          }),
        ]),
        _c("div", { staticClass: "themed-text" }, [
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          _vm.showDetail
            ? _c("p", [
                _vm._v(
                  "Xem chi tiết thông số chu kỳ chạy và mô tả của Cronjob tự động."
                ),
              ])
            : _c("p", [
                _vm._v(
                  "Cập nhật thông số chu kỳ, khóa hoạt động và mô tả tác vụ tự động chạy."
                ),
              ]),
        ]),
      ]),
      _c(
        "el-form",
        {
          ref: "formData",
          staticClass: "modern-dialog-form",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-position": "top",
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _vm._v(" Thông tin cơ bản"),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Tên hoạt động", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              placeholder: "Tên hoạt động",
                            },
                            model: {
                              value: _vm.formData.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "name", $$v)
                              },
                              expression: "formData.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Mã hoạt động (Job Key)",
                            prop: "jobKey",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              placeholder: "Khóa Job Key",
                            },
                            model: {
                              value: _vm.formData.jobKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "jobKey", $$v)
                              },
                              expression: "formData.jobKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Loại cấu hình", prop: "category" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-full",
                              attrs: {
                                disabled: _vm.showDetail,
                                placeholder: "Chọn loại cấu hình",
                              },
                              model: {
                                value: _vm.formData.category,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "category", $$v)
                                },
                                expression: "formData.category",
                              },
                            },
                            _vm._l(_vm.categoryOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-date" }),
                _vm._v(" Chu kỳ hoạt động"),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Thời gian hoạt động (Cron Expression)",
                            prop: "cronExpression",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              placeholder: "Biểu thức Cron",
                            },
                            model: {
                              value: _vm.formData.cronExpression,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "cronExpression", $$v)
                              },
                              expression: "formData.cronExpression",
                            },
                          }),
                          _c("div", { staticClass: "cron-tip" }, [
                            _c("i", { staticClass: "el-icon-info" }),
                            _vm._v(
                              " Định dạng: #giây #phút #giờ #ngày_trong_tháng #tháng #ngày_trong_tuần\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-notebook-2" }),
                _vm._v(" Chi tiết mô tả"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      disabled: _vm.showDetail,
                      placeholder: "Mô tả chức năng chi tiết...",
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }